import { gql } from '../../config/connected'

const userFields = `
  id
  username
  displayName
  profileImage
  title
  organization
  organizationId
  iFollow
`

export default {
  queries: {
    following: gql`
      query($userId: String!) {
        following(userId: $userId) {
          ${userFields}
        }
      }
    `,
  },
}
